// extracted by mini-css-extract-plugin
module.exports = {"paletteOuter":"palette_paletteOuter__-62kw","swatchHolder":"palette_swatchHolder__1D0Cu","swatchCount":"palette_swatchCount__2sE0n","swatchNumber":"palette_swatchNumber__3UQB0"};